import Divider from '@material-ui/core/Divider'
import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'
import clsx from 'clsx'
import { useId } from 'react'
import { useTranslation } from 'react-i18next'
import { currency } from 'src/data/currency'

const useStyles = makeStyles((theme) => ({
	autocompleteOption: {
		'&[aria-disabled="true"]': {
			opacity: 1,
		},
		'& hr': {
			width: '100%',
		},
	},
	small: {
		'& div': {
			'& label': {
				transform: 'translate(14px, 10px) scale(1)',
			},
			'& div': {
				paddingTop: '0 !important',
				paddingBottom: '0 !important',
			},
		},
	},
}))

function CurrencyAutoComplete({
	props,
	required,
	handleChange,
	errors,
	forceSmall,
	disabled,
	label,
}: {
	props?: any
	required: boolean
	handleChange: (data: any) => void
	errors: any
	forceSmall?: boolean
	disabled?: boolean
	label?: string
}) {
	const classes = useStyles()
	const { t } = useTranslation()
	const { t: tSuppliers } = useTranslation('suppliers')
	const { t: tProjectChildren } = useTranslation('projectChildren')
	const autocompleteId = useId()

	return (
		<Autocomplete
			id={autocompleteId}
			{...props}
			fullWidth
			disabled={disabled}
			size="small"
			options={currency.map((c) => c.code)}
			classes={{
				option: classes.autocompleteOption,
			}}
			className={clsx({
				[classes.small]: forceSmall,
			})}
			getOptionLabel={(option) =>
				currency
					?.filter((c) => c.code === option)
					.map((c) => `${c.code} - ${c.name}`)[0]
			}
			getOptionDisabled={(option) =>
				currency?.filter((c) => c.code === option)[0].isDivider
			}
			renderOption={(option) => {
				if (currency?.filter((c) => c.code === option)[0].isDivider) {
					return <Divider />
				}

				return currency
					?.filter((c) => c.code === option)
					.map((c) => `${c.code} - ${c.name}`)[0]
			}}
			renderInput={(params) => (
				<>
					<TextField
						{...params}
						label={
							label ||
							tSuppliers(
								'addSuppliersModal.sections.sectionFive.currency'
							)
						}
						variant="outlined"
						fullWidth
						size="medium"
						required={required}
						error={errors?.currency?.type === 'required'}
						helperText={
							errors?.currency?.type === 'required'
								? tProjectChildren(
										'addQuoteModal.sections.sectionTwo.errorMsg.required'
									)
								: ''
						}
					/>
				</>
			)}
			onChange={(_, data) => {
				return handleChange(data)
			}}
		/>
	)
}

export default CurrencyAutoComplete
